module.exports = __webpack_public_path__ + "img/ic-pwp-mepoint.png";